import React, { useEffect, Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import Chatbox from "./Components/Chatbox/Chatbox";
import LoadingSpinner from "../src/spinner";

const Home = lazy(() => import("./Components/Home/Home"));
const About = lazy(() => import("./Components/About/About"));
const Commercial = lazy(() => import("./Components/Commercial/Commercial"));
const Residential = lazy(() => import("./Components/Residential/Residential"));
const Officespace = lazy(() => import("./Components/OfficeSpace/Officespace"));
const Contact = lazy(() => import("./Components/Contact/Contact"));
const Exclusive1 = lazy(() => import("./Components/Exclusive1/Exclusive1"));
const Exclusive2 = lazy(() => import("./Components/Exclusive2/Exclusive2"));
const Exclusive3 = lazy(() => import("./Components/Exclusive3/Exclusive3"));
const Exclusive4 = lazy(() => import("./Components/Exclusive4/Exclusive4"));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'  
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <Router>
        <Header />
        <ScrollToTop />
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/residential" element={<Residential />} />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/officespace" element={<Officespace />} />
            <Route path="/exclusive1" element={<Exclusive1 />} />
            <Route path="/exclusive2" element={<Exclusive2 />} />
            <Route path="/exclusive3" element={<Exclusive3 />} />
            <Route path="/exclusive4" element={<Exclusive4 />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Suspense>
        <Footer />
        <Chatbox />
      </Router>
    </>
  );
}

export default App;
